import request from '@/utils/request'

// 获取通知公告数据
export const getTzggData = (pageNo, pageSize) => {
	return request.get(`/client/user/oaNotify/list?pageNo=${pageNo}&pageSize=${pageSize}`, {
	})
}
